import { render, staticRenderFns } from "./AnomalaView.vue?vue&type=template&id=1a2601cb"
import script from "./AnomalaView.vue?vue&type=script&lang=js"
export * from "./AnomalaView.vue?vue&type=script&lang=js"
import style0 from "./AnomalaView.vue?vue&type=style&index=0&id=1a2601cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports